import { useI18n } from '@i18n/I18nProvider'
import { BottomSheet } from '@ui/BottomSheet'
import { Icon } from '@ui/Icon'
import { useState } from 'react'
import { Legend } from './Legend'

// Botón "i" del mapa: la leyenda no ocupa pantalla; se abre en una hoja inferior al pedirla.
// Va bajo el botón "Etapas" (arriba a la izquierda); los controles de MapLibre están a la derecha.
export const LegendButton = ({ withStageEnds = false }: { withStageEnds?: boolean }) => {
	const { t } = useI18n()
	const [open, setOpen] = useState(false)
	return (
		<>
			<button
				type="button"
				aria-label={t('map.legendOpen')}
				aria-haspopup="dialog"
				aria-expanded={open}
				onClick={() => setOpen(true)}
				className="absolute top-[4.25rem] left-3 z-10 flex size-12 items-center justify-center rounded-full bg-white text-forest-800 shadow-md active:bg-earth-100"
			>
				<Icon name="info" />
			</button>
			{open && (
				<BottomSheet title={t('map.legend')} onClose={() => setOpen(false)}>
					<Legend withStageEnds={withStageEnds} />
				</BottomSheet>
			)}
		</>
	)
}
